import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: string) =>
  store.dispatch(appActions.setCurrentPage(pageIndex));

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "lead-time-reduction",
    iconColor: "white",
    text: "Lead time\nreduction",
    listItemCustomStyle: { width: "182px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "graphDownArrowWithDollarSign",
    iconColor: "white",
    text: "OpEx cost\nreduction ",
    listItemCustomStyle: { width: "182px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "automatic-case",
    iconColor: "white",
    text: "Automatic case\nand notification\ncreation",
    listItemCustomStyle: { width: "182px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "like-finger",
    iconColor: "white",
    text: "Customer \nand agent\nsatisfaction",
    listItemCustomStyle: { width: "182px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const data = {
  styleLeftPanel: { paddingRight: 0 },
  title: "Network \noperations",
  text: "Automatic handling of network alarms utilizes closed-loop automation, \nautomatic case management, and proactive communication.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  styleListData: { marginTop: "43px" },
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage("ILO_202"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_2"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_Introduction_01.png",
  //rightSideImage: "Network-lifecycle-stages.png",
};

export default data;
